import Time from '@article/time';
import { computed } from '@vue/composition-api';
import DateUtils from '@/components/commons/DateUtils';
import { DateTime } from 'luxon';

const formatDate = (timeString, defaultTimeString) => {
  const currentTime = new Date(Date.now());

  const time = {
    year: currentTime.getFullYear(),
    month: currentTime.getMonth() + 1,
    date: currentTime.getDate(),
  };

  const baseDateString = `${time.year}/${time.month}/${time.date}`;

  if (!timeString) {
    timeString = defaultTimeString;
  }

  if (DateUtils.isValidDateFormat(`${baseDateString} ${timeString}`, undefined, 'America/Vancouver')) {
    return DateTime.fromFormat(`${baseDateString} ${timeString}`, 'yyyy/M/d h:mm a', {
      zone: 'America/Vancouver',
    }).toJSDate();
  }

  if (defaultTimeString) {
    return DateTime.fromFormat(`${baseDateString} ${defaultTimeString}`, 'yyyy/M/d h:mm a', {
      zone: 'America/Vancouver',
    }).toJSDate();
  }

  return null;
};

export default function useSupportHours(commonState = {}) {
  const csPhoneWeekdaysHoursStart = computed(() => formatDate(commonState.csPhoneWeekdaysHoursStart, '7:00 AM'));
  const csPhoneWeekdaysHoursEnd = computed(() => formatDate(commonState.csPhoneWeekdaysHoursEnd, '5:00 PM'));
  const csPhoneWeekendHoursStart = computed(() => formatDate(commonState.csPhoneWeekendHoursStart));
  const csPhoneWeekendHoursEnd = computed(() => formatDate(commonState.csPhoneWeekendHoursEnd));
  const csChatWeekdaysHoursStart = computed(() => formatDate(commonState.csChatWeekdaysHoursStart, '8:00 AM'));
  const csChatWeekdaysHoursEnd = computed(() => formatDate(commonState.csChatWeekdaysHoursEnd, '5:00 PM'));
  const csChatWeekendHoursStart = computed(() => formatDate(commonState.csChatWeekendHoursStart));
  const csChatWeekendHoursEnd = computed(() => formatDate(commonState.csChatWeekendHoursEnd));
  const csChatOverlayWeekdaysHoursStart = computed(() => formatDate(commonState.csChatOverlayWeekdaysHoursStart, '8:00 AM'));
  const csChatOverlayWeekdaysHoursEnd = computed(() => formatDate(commonState.csChatOverlayWeekdaysHoursEnd, '5:00 PM'));
  const csChatOverlayWeekendHoursStart = computed(() => formatDate(commonState.csChatOverlayWeekendHoursStart));
  const csChatOverlayWeekendHoursEnd = computed(() => formatDate(commonState.csChatOverlayWeekendHoursEnd));

  const csPhoneWeekdaysHoursStartText = computed(() => Time.renderDate(csPhoneWeekdaysHoursStart.value, 'H'));

  const csPhoneWeekdaysHoursEndText = computed(() => Time.renderDate(csPhoneWeekdaysHoursEnd.value, 'HT'));

  const csPhoneWeekendHoursStartText = computed(() => {
    if (csPhoneWeekendHoursStart.value) {

      return Time.renderDate(csPhoneWeekendHoursStart.value, 'H');
    }

    return null;
  });

  const csPhoneWeekendHoursEndText = computed(() => {
    if (csPhoneWeekendHoursEnd.value) {
      return Time.renderDate(csPhoneWeekendHoursEnd.value, 'HT');
    }

    return null;
  });

  const csChatWeekdaysHoursStartText = computed(() => Time.renderDate(csChatWeekdaysHoursStart.value, 'H'));

  const csChatWeekdaysHoursEndText = computed(() => Time.renderDate(csChatWeekdaysHoursEnd.value, 'HT'));

  const csChatWeekendHoursStartText = computed(() => {
    if (csChatWeekendHoursStart.value) {
      return Time.renderDate(csChatWeekendHoursStart.value, 'H');
    }

    return null;
  });

  const csChatWeekendHoursEndText = computed(() => {
    if (csChatWeekendHoursEnd.value) {
      return Time.renderDate(csChatWeekendHoursEnd.value, 'HT');
    }

    return null;
  });

  const phoneOnlyWeekdays = computed(() => !csPhoneWeekendHoursStart.value || !csPhoneWeekendHoursEnd.value);

  const chatOnlyWeekdays = computed(() => !csChatWeekendHoursStart.value || !csChatWeekendHoursEnd.value);

  const phoneSameHours = computed(
    () => csPhoneWeekdaysHoursStart.value?.getTime() === csPhoneWeekendHoursStart.value?.getTime() &&
      csPhoneWeekdaysHoursEnd.value?.getTime() === csPhoneWeekendHoursEnd.value?.getTime(),
  );

  const chatSameHours = computed(
    () => csChatWeekdaysHoursStart.value?.getTime() === csChatWeekendHoursStart.value?.getTime() &&
      csChatWeekdaysHoursEnd.value?.getTime() === csChatWeekendHoursEnd.value?.getTime(),
  );

  return {
    csPhoneWeekdaysHoursStart,
    csPhoneWeekdaysHoursEnd,
    csPhoneWeekendHoursStart,
    csPhoneWeekendHoursEnd,
    csChatWeekdaysHoursStart,
    csChatWeekdaysHoursEnd,
    csChatWeekendHoursStart,
    csChatWeekendHoursEnd,
    csChatOverlayWeekdaysHoursStart,
    csChatOverlayWeekdaysHoursEnd,
    csChatOverlayWeekendHoursStart,
    csChatOverlayWeekendHoursEnd,
    csPhoneWeekdaysHoursStartText,
    csPhoneWeekdaysHoursEndText,
    csPhoneWeekendHoursStartText,
    csPhoneWeekendHoursEndText,
    csChatWeekdaysHoursStartText,
    csChatWeekdaysHoursEndText,
    csChatWeekendHoursStartText,
    csChatWeekendHoursEndText,
    phoneOnlyWeekdays,
    chatOnlyWeekdays,
    phoneSameHours,
    chatSameHours,
  };
}
